import { MutableRefObject, useRef } from 'react';

export function useUpdatingRef<T>(value: T): MutableRefObject<T> {
    const valueRef = useRef(value);
    valueRef.current = value;

    return valueRef;
}
